<template>
	<pro-layout :menus="menus" :collapsed="collapsed" :mediaQuery="query" :isMobile="isMobile"
		:handleMediaQuery="handleMediaQuery" :handleCollapse="handleCollapse" :i18nRender="i18nRender" v-bind="settings"
		:sider-width="200">
		<!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads
    -->
		<!-- <ads v-if="isProPreviewSite&&!collapsed"/> -->
		<ads v-if="!collapsed" />
		<!-- Ads end -->

		<!-- 1.0.0+ 版本 pro-layout 提供 API，我们推荐使用这种方式进行 LOGO 和 title 自定义 -->
		<template v-slot:menuHeaderRender>
			<div style="margin-left: -5px;" v-if="types==0">
				<img src="../../public/images/loggo.png" style="width: 50px" />
				<h1>{{ title }}</h1>
			</div>
			<div style="margin-left: -5px;" v-else>
				<img src="../../public/images/loggo.png" style="width: 50px" />
				<h1>报价系统</h1>
			</div>
		</template>

		<!-- <setting-drawer :settings="settings" @change="handleSettingChange" /> -->
		<template v-slot:rightContentRender>
			<right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" />
		</template>
		<!-- <template v-slot:footerRender>
      <global-footer />
    </template> -->
		<router-view />
		<!-- 客服按钮 -->
		<!-- <div class="service">
      <div class="img_box" @click="showMsg">
        <img src="../../public/images/service.png" alt="" />
      </div>
      <div class="txt">在线客服</div>
    </div> -->
		<!-- <div class="service" style="bottom: 10px">
      <div class="img_box" @click="showBook">
        <img src="../../public/images/message.png" alt="" />
      </div>
      <div class="txt">问题反馈</div>
    </div> -->

		<!-- 客服弹框 -->
		<div class="shade" v-if="is_message">
			<div class="shade_box">
				<div class="shade_top">
					<span>在线客服</span>
					<a-icon class="icon" title="关闭" @click="closeMessage" type="close" />
				</div>
				<div class="chat">
					<div class="chat_item" v-for="(item, index) in charts" :key="index">
						<div :class="item.userId == 1 ? 'head' : 'head2'">
							<img :src="item.head" alt="" />
						</div>
						<div :class="item.userId == 1 ? 'chat_val' : 'chat_val2'" v-html="item.val"></div>
					</div>
				</div>
				<div class="send">
					<div class="text_send" contenteditable="true" @blur="message = $event.target.innerText"
						placeholder="请输入" id="innerTxt" ref="innerTxt"></div>
					<div class="send_Btn" @click="sendMsg">发送</div>
				</div>
			</div>
		</div>
		<!-- 反馈弹框 -->
		<div class="shade" v-if="is_book">
			<div class="shade_box" style="bottom: 10px">
				<div class="shade_top">
					<span>问题反馈</span>
					<a-icon class="icon" title="关闭" @click="closeBook" type="close" />
				</div>
				<div class="chart2">
					<div class="msg" contenteditable="true" ref="feedback" @input="blurBook($event)"></div>
					<div class="max_leng">{{ feedbackLen }}/2000</div>
				</div>
				<div class="send2">
					<div class="sendBtn" @click="sendBook">提交</div>
				</div>
			</div>
		</div>
		<audio ref="controls" id="controls">
			<source src="../../public/unit.mp3" type="audio/ogg" />
			<source src="../../public/unit.mp3" type="audio/mpeg" />
			您的浏览器不支持 audio 元素。
		</audio>
	</pro-layout>
</template>

<script>
	var socket
	var ip = null
	// socket = io.connect('http://192.168.0.222:8083?userId=3', {
	//   transports: ['websocket'],
	//   userId: 3,
	// })
	// socket.on('connect', (data) => {
	//   console.log(data)
	//   console.log('客户端连接到服务端')
	//   // $('#console').text(NowTime() + '客户端连接到服务端')
	// })
	// socket.on('getip', function (data) {
	//   console.log(data)
	// })
	// socket.on('chatevent', function (data) {
	//   console.log(data)
	// })
	// socket.on('receiveMsg', function (data) {
	//   console.log(data)
	//   socket.disconnect();
	// })
	import {
		SettingDrawer,
		updateTheme
	} from '@ant-design-vue/pro-layout'
	import {
		i18nRender
	} from '@/locales'
	import {
		mapState
	} from 'vuex'
	import storage from 'store'
	import {
		CONTENT_WIDTH_TYPE,
		SIDEBAR_TYPE,
		TOGGLE_MOBILE_TYPE,
		TOGGLE_NAV_THEME,
		TOGGLE_COLOR,
	} from '@/store/mutation-types'
	import defaultSettings from '@/config/defaultSettings'
	import RightContent from '@/components/GlobalHeader/RightContent'
	// import GlobalFooter from '@/components/GlobalFooter'
	import Ads from '@/components/Other/CarbonAds'

	export default {
		name: 'BasicLayout',
		components: {
			SettingDrawer,
			RightContent,
			// GlobalFooter,
			Ads,
		},
		data() {
			return {
				// base
				menus: {},
				// 侧栏收起状态
				collapsed: false,
				title: defaultSettings.title,
				settings: {
					// 布局类型
					layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
					// 定宽: true / 流式: false
					contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings
						.contentWidth,
					// 主题 'dark' | 'light'
					theme: defaultSettings.navTheme,
					// 主色调
					primaryColor: storage.get(TOGGLE_COLOR) || defaultSettings.primaryColor,
					fixedHeader: defaultSettings.fixedHeader,
					fixSiderbar: defaultSettings.fixSiderbar,
					colorWeak: defaultSettings.colorWeak,

					hideHintAlert: false,
					hideCopyButton: false,
				},
				// 媒体查询
				query: {},
				// 是否手机模式
				isMobile: false,
				message: '',
				is_message: false,
				charts: [{
						head: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202011%2F17%2F20201117105437_45d41.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640142335&t=0fa66775f3213246c9f92da2228892d3',
						val: '你好,有什么可以帮助你?',
						userId: 1,
					},
					{
						head: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2F62%2F3b%2Fe1%2F623be1bed1dcdbc71ee2dc3c28505aed.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640142907&t=9c7e44e973f4370a3a1b3f6939cc7aac',
						val: '要不要打一把Dota!带带我！',
						userId: 2,
					},
				],
				feedback: '',
				feedbackLen: 0,
				is_book: false,
				ws: null,
				types: 0,
			}
		},
		computed: {
			...mapState({
				// 动态主路由
				mainMenu: (state) => state.permission.addRouters,
			}),
		},
		watch: {
			'$store.state.user.nav_type'(newVal, oldVal) {
				//对数据进行操作
				console.log(newVal, 'newValnewValnewValnewValnewValnewValnewValnewValnewValnewValnewVal')
				this.types = newVal
				const routes = this.mainMenu.find((item) => item.path === '/')
				this.menus = (routes && routes.children) || [];
				console.log(this.menus,'this.menusthis.menusthis.menus')
				if (this.types == 0) {
					console.log(this.menus)
					this.menus = this.menus.filter((item) => item.path != '/Quotation' && item.path != '/Quotation/record' && item.path != '/Quotation/post'
					&& item.path != '/Quotation/surroundings' && item.path != '/Quotation/public' && item.path != '/Quotation/service'&& item.path != '/Quotation/customer')
				} else if (this.types == 1) {
					this.menus = this.menus.filter((item) => item.path == '/Quotation' || item.path == '/Quotation/record' || item.path == '/Quotation/post'
					|| item.path == '/Quotation/surroundings' || item.path == '/Quotation/public' || item.path == '/Quotation/service'|| item.path == '/Quotation/customer')
				}
			}
		},
		created() {
			const routes = this.mainMenu.find((item) => item.path === '/')
			this.menus = (routes && routes.children) || [];
			console.log(this.menus)
			this.menus = this.menus.filter((item) => item.path != '/Quotation' && item.path != '/Quotation/record' && item.path != '/Quotation/post'
			&& item.path != '/Quotation/surroundings' && item.path != '/Quotation/public' && item.path != '/Quotation/service' && item.path != '/Quotation/customer')
			console.log(this.menus, 'menusmenusmenusmenusmenusmenus')
			// 处理侧栏收起状态
			this.$watch('collapsed', () => {
				this.$store.commit(SIDEBAR_TYPE, this.collapsed)
			})
			this.$watch('isMobile', () => {
				this.$store.commit(TOGGLE_MOBILE_TYPE, this.isMobile)
			})
		},
		mounted() {

			// if ('WebSocket' in window) {
			//   this.ws = new WebSocket('ws://192.168.0.222:8083/socket-io')
			// } else if ('MozWebSocket' in window) {
			//   this.ws = new MozWebSocket('ws://192.168.0.222:8083/socket-io')
			// }
			// switch (this.ws.readyState) {
			//   case WebSocket.CONNECTING:
			//     console.log(0)
			//     break
			//   case WebSocket.OPEN:
			//     console.log(1)
			//     break
			//   case WebSocket.CLOSING:
			//     console.log(2)
			//     break
			//   case WebSocket.CLOSED:
			//     console.log(3)
			//     break
			//   default:
			//     // this never happens
			//     break
			// }

			// this.ws.onopen = (evt) => {
			//   console.log('连接成功')
			// }
			// this.ws.onmessage = (evt) => {
			//   console.log(evt.data)
			//   var audio = document.getElementById('controls')
			//   audio.play()
			// }
			// ws.onclose = function (evt) {
			//   console.log('链接断开')
			// }

			const userAgent = navigator.userAgent
			if (userAgent.indexOf('Edge') > -1) {
				this.$nextTick(() => {
					this.collapsed = !this.collapsed
					setTimeout(() => {
						this.collapsed = !this.collapsed
					}, 16)
				})
			}
			// first update color
			// TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
			// if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
			// updateTheme(this.settings.primaryColor)
			// }
		},
		methods: {
			i18nRender,
			handleMediaQuery(val) {
				this.query = val
				if (this.isMobile && !val['screen-xs']) {
					this.isMobile = false
					return
				}
				if (!this.isMobile && val['screen-xs']) {
					this.isMobile = true
					this.collapsed = false
					this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
					// this.settings.fixSiderbar = false
				}
			},
			handleCollapse(val) {
				this.collapsed = val
			},
			handleSettingChange({
				type,
				value
			}) {
				console.log('type', type, value)
				type && (this.settings[type] = value)
				switch (type) {
					case 'contentWidth':
						this.settings[type] = value
						break
					case 'layout':
						if (value === 'sidemenu') {
							this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
						} else {
							this.settings.fixSiderbar = false
							this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
						}
						break
					case 'primaryColor':
						this.$store.commit(TOGGLE_COLOR, value)
						break
					case 'theme':
						this.$store.commit(TOGGLE_NAV_THEME, value)
						break
				}
			},
			logoRender() {
				
				return
			},
			//点击弹出客服
			showMsg() {
				this.is_message = true
			},
			//发送消息
			sendMsg() {
				var my_user_id = this.$store.getters.userInfo.userId
				var obj = {
					userId: my_user_id,
					message: '三┏ (  ˘ω˘ )┛早睡早起',
				}
				this.ws.send(JSON.stringify(obj))
				if (!this.message) {
					return
				}
				this.charts.push({
					head: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2F62%2F3b%2Fe1%2F623be1bed1dcdbc71ee2dc3c28505aed.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640142907&t=9c7e44e973f4370a3a1b3f6939cc7aac',
					val: this.message,
					userId: 2,
				})
				this.message = ''
				this.$refs.innerTxt.innerHTML = ''
			},
			//关闭弹框
			closeMessage() {
				this.is_message = false
			},
			//内容改变
			blurBook(e) {
				this.feedback = e.target.innerText
				this.feedbackLen = e.target.innerText.length
			},
			//弹出反馈
			showBook() {
				this.is_book = true
			},
			closeBook() {
				this.is_book = false
			},
			//提交反馈
			sendBook() {
				if (!this.feedback) {
					return
				}
				this.$message.success('反馈已提交')
				this.feedback = ''
				this.feedbackLen = 0
				this.$refs.feedback.innerHTML = ''
				this.closeBook()
			},
		},
	}
</script>

<style lang="less" scped>
	@import './BasicLayout.less';

	.service {
		position: fixed;
		right: 0;
		bottom: 100px;
		z-index: 99;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #fff;

		.img_box {
			width: 50px;
			height: 50px;
			background: #1890ff;
			float: left;
			border-radius: 5px;
			cursor: pointer;
			transition: 0.4s;
			display: flex;
			justify-content: center;
			align-items: center;

			&:hover {
				background: #5cb0ff;
			}

			img {
				width: 100%;
			}
		}

		.txt {
			width: 100%;
			margin-top: 5px;
			float: left;
			font-size: 14px;
			font-weight: 600;
			color: #1890ff;
		}
	}

	.shade {
		width: 100%;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.493);
		z-index: 9999;

		.shade_box {
			position: absolute;
			right: 60px;
			bottom: 100px;
			width: 350px;
			height: 450px;
			background: #ddd;

			.shade_top {
				width: 100%;
				height: 40px;
				background: #1890ff;
				color: #fff;
				padding: 15px;
				box-sizing: border-box;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.icon {
					font-size: 20px;
					cursor: pointer;
				}
			}

			.chat {
				width: 100%;
				height: calc(100% - 40px - 40px);
				float: left;
				background: #fff;
				border-bottom: 1px solid #ddd;
				padding: 5px 10px;
				box-sizing: border-box;
				overflow-y: scroll;

				&::-webkit-scrollbar {
					width: 3px;
				}

				&::-webkit-scrollbar-thumb {
					border-radius: 10px;
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
					background: rgba(0, 0, 0, 0.2);
				}

				&::-webkit-scrollbar-track {
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
					border-radius: 0;
					background: rgba(0, 0, 0, 0.1);
				}

				.chat_item {
					width: 100%;
					float: left;
					margin-bottom: 15px;

					.head {
						width: 35px;
						height: 35px;
						float: left;
						border-radius: 5px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}

					.head2 {
						width: 35px;
						height: 35px;
						float: right;
						border-radius: 5px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}

					.chat_val {
						max-width: calc(100% - 35px - 50px);
						float: left;
						margin-left: 10px;
						font-size: 13px;
						line-height: 20px;
						min-height: 35px;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						color: #000;
					}

					.chat_val2 {
						max-width: calc(100% - 35px - 50px);
						float: right;
						margin-right: 10px;
						font-size: 13px;
						line-height: 20px;
						min-height: 35px;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						color: #000;
					}
				}
			}

			.send {
				width: 100%;
				min-height: 40px;
				max-height: 70px;
				float: left;
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				font-size: 13px;
				background: #fff;

				.text_send {
					width: calc(100% - 60px);
					float: left;
					outline: none;
					line-height: 20px;
					height: auto;
					min-height: 40px;
					max-height: 70px;
					overflow-y: scroll;
					padding-left: 5px;
					box-sizing: border-box;

					&::-webkit-scrollbar {
						width: 3px;
					}
				}

				.text_send::-webkit-scrollbar-thumb {
					border-radius: 10px;
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
					background: rgba(0, 0, 0, 0.2);
				}

				.text_send::-webkit-scrollbar-track {
					-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
					border-radius: 0;
					background: rgba(0, 0, 0, 0.1);
				}

				.text_send:empty:before {
					content: '请输入...';
					color: gray;
				}

				.text_send:focus:before {
					content: none;
				}

				.send_Btn {
					color: #fff;
					background: #1890ff;
					cursor: pointer;
					margin-bottom: 5px;
					margin-right: 5px;
					padding: 5px 10px;
					border-radius: 5px;
				}
			}

			.chart2 {
				width: 100%;
				height: calc(100% - 40px - 40px);
				float: left;

				padding: 8px;
				box-sizing: border-box;

				.msg {
					width: 100%;
					height: calc(100% - 20px);
					float: left;
					overflow-y: scroll;
					background: #fff;
					padding: 5px;
					box-sizing: border-box;
					line-height: 22px;
					outline: none;
					font-size: 13px;

					&::-webkit-scrollbar {
						width: 3px;
					}

					&::-webkit-scrollbar-thumb {
						border-radius: 10px;
						-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
						background: rgba(0, 0, 0, 0.2);
					}

					&::-webkit-scrollbar-track {
						-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
						border-radius: 0;
						background: rgba(0, 0, 0, 0.1);
					}

					&:empty:before {
						content: '请输入...';
						color: gray;
					}

					&:focus:before {
						content: none;
					}
				}

				.max_leng {
					width: 100%;
					display: flex;
					height: 20px;
					justify-content: flex-end;
					align-items: center;
					background: #fff;
				}
			}

			.send2 {
				width: 100%;
				height: 40px;
				background: #fff;
				float: left;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				padding: 0 8px;
				box-sizing: border-box;

				.sendBtn {
					background: #1890ff;
					font-size: 13px;
					padding: 4px 15px;
					cursor: pointer;
					border-radius: 5px;
					color: #fff;
				}
			}
		}
	}
</style>
